<template>
    <div class="file-upload">
        <div class="text-xl font-bold mb-4">Guideline Overview</div>
        <div class="mb-6">
            <FormTextLabel
                v-model="form.label"
                id="title"
                label="Guideline Overview Label"
                subtitle="Add a title that describes this item."
                placeholderText="Add a Guideline Overview"
                containerClass="mb-6"
                :error="errors.title ? errors.title[0] : ''"
            />
            <button
                class="
                    bg-blue-500
                    hover:bg-blue-700
                    text-white
                    font-bold
                    py-2
                    px-4
                "
                @click="save()"
            >
                Save
            </button>
        </div>
    </div>
    
</template>

<script>
import axios from 'axios';
import AppLayout from "@/Layouts/AppLayout";
import flatPickr from "vue-flatpickr-component";
import FormTextLabel from "@/components/FormTextLabel";

export default {
    props: [],
    emits: ["uploadComplete"],
    components: {
        AppLayout,
        flatPickr,
        FormTextLabel,
    },
    data() {
        return {
            form: {
                "type" : "brand-guideline-overview"
            },
            errors: {},
        };
    },
    methods: {
        save() {
            this.isLoading = true;

            axios
                .post(`/api/brand-guideline`, this.form)
                .then((response) => {
                    this.$emit("uploadComplete");
                })
                .catch((error) => {
                    this.savedError();
                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                        }
                    } else if (error.request) {
                        // console.log(error.request);
                    } else {
                        // console.log("Error", error.message);
                    }
                });

            this.isLoading = false;
        }
    },
};
</script>

<style scoped>
</style>
